import { CreateBlankPricePeriod } from '@features/TimberBuyer/SalesAgreements/PricePeriods/Create/CreateBlankPricePeriod'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const CreateBlankPricePeriodRoute: React.FC = () => {
  const { timberBuyerId, salesAgreementId } = Route.useParams()

  return (
    <CreateBlankPricePeriod timberBuyerId={timberBuyerId} salesAgreementId={salesAgreementId} />
  )
}

export const Route = createFileRoute(
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/create/',
)({
  component: CreateBlankPricePeriodRoute,
  staticData: {
    breadcrumb: t('timberbuyer-salesagreements-priceperiods.createEmpty.breadcrumb'),
  },
})
